var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicensePreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 1.32031V4.49696C11.0596 4.70759 11.1432 4.90958 11.2922 5.05852C11.4411 5.20745 11.6431 5.29112 11.8537 5.29112H15.0304",
    stroke: "#475569",
    strokeWidth: 1.58832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91113 5.29112V2.90864C3.91113 2.48739 4.07847 2.08339 4.37634 1.78552C4.67421 1.48765 5.07821 1.32031 5.49946 1.32031H11.0586L15.0294 5.29112V14.0269C15.0294 14.4482 14.8621 14.8522 14.5642 15.15C14.2663 15.4479 13.8623 15.6152 13.4411 15.6152H9.47027",
    stroke: "#475569",
    strokeWidth: 1.58832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70573 12.4447C6.02154 12.4447 7.08822 11.378 7.08822 10.0622C7.08822 8.74636 6.02154 7.67969 4.70573 7.67969C3.38992 7.67969 2.32324 8.74636 2.32324 10.0622C2.32324 11.378 3.38992 12.4447 4.70573 12.4447Z",
    stroke: "#475569",
    strokeWidth: 1.58832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51449 12.4375L2.32324 16.4083L4.70573 15.2171L7.08822 16.4083L5.89697 12.4375",
    stroke: "#475569",
    strokeWidth: 1.58832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensePreview);
export default __webpack_public_path__ + "static/media/license-preview.dd1d9cc1.svg";
export { ForwardRef as ReactComponent };